import { render, staticRenderFns } from "./FormSelect.vue?vue&type=template&id=3c5a10ca&scoped=true"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"
import style0 from "./FormSelect.vue?vue&type=style&index=0&id=3c5a10ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a10ca",
  null
  
)

export default component.exports